import { useState } from "react";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Typography,
  FormControlLabel,
  Checkbox,
  Divider,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid"; // ✅ Grid2 supports size prop
import { UploadImages } from "../../../Core/UploadImages";
import uploadicon from "../../../assets/Images/Businesses/Upload-Normal.png";

export type User = {
  _id: string;
  emailId: string;
  phoneNumber: string;
  phoneCountryCode: string;
  socialLoginType: string;
  isDelete: boolean;
  dateOfBirth: string; // ISO string
  fullName: string;
  gender: string;
  profileImagePath: string;
  isApproved: boolean;
  role: number;
  addressType: string;
  city: string;
  zipCode: string;
  country: string;
  stateOrRegion: string;
  latitude: number;
  longitude: number;
  addressIsDelete: boolean;
};

export default function AddUserPage() {
  const [form, setForm] = useState<User>({
    _id: "",
    emailId: "",
    phoneNumber: "",
    phoneCountryCode: "+91",
    socialLoginType: "None",
    isDelete: false,
    dateOfBirth: new Date().toISOString(),
    fullName: "",
    gender: "Male",
    profileImagePath: "",
    isApproved: false,
    role: 0,
    addressType: "Current",
    city: "",
    zipCode: "",
    country: "",
    stateOrRegion: "",
    latitude: 0,
    longitude: 0,
    addressIsDelete: false,
  });

  const handleChange = (field: keyof User, value: any) => {
    setForm({ ...form, [field]: value });
  };

  const handleSubmit = () => {
  
  };

  return (
    <Box sx={{ p: 3, backgroundColor: "#ffffffcb" }}>

      <Grid container spacing={3}>
        {/* Personal Details */}
        <Grid size={12}>
          <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h6" gutterBottom>
              👤 Personal Details
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Full Name"
                  value={form.fullName}
                  onChange={(e) => handleChange("fullName", e.target.value)}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  value={form.emailId}
                  onChange={(e) => handleChange("emailId", e.target.value)}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  select
                  fullWidth
                  label="Country Code"
                  value={form.phoneCountryCode}
                  onChange={(e) =>
                    handleChange("phoneCountryCode", e.target.value)
                  }
                >
                  <MenuItem value="+91">+91 (India)</MenuItem>
                  <MenuItem value="+1">+1 (USA)</MenuItem>
                  <MenuItem value="+44">+44 (UK)</MenuItem>
                </TextField>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  value={form.phoneNumber}
                  onChange={(e) => handleChange("phoneNumber", e.target.value)}
                />
              </Grid>



              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  select
                  fullWidth
                  label="Gender"
                  value={form.gender}
                  onChange={(e) => handleChange("gender", e.target.value)}
                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                  <MenuItem value="Prefer Not To Say">
                    Prefer Not To Say
                  </MenuItem>
                </TextField>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  select
                  fullWidth
                  label="Role"
                  value={form.role}
                  onChange={(e) => handleChange("role", Number(e.target.value))}
                >
                  <MenuItem value={0}>User</MenuItem>
                  <MenuItem value={1}>Admin</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Address */}
        <Grid size={12}>
          <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h6" gutterBottom>
              🏠 Address Details
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="City"
                  value={form.city}
                  onChange={(e) => handleChange("city", e.target.value)}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="State / Region"
                  value={form.stateOrRegion}
                  onChange={(e) => handleChange("stateOrRegion", e.target.value)}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Country"
                  value={form.country}
                  onChange={(e) => handleChange("country", e.target.value)}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Zip Code"
                  value={form.zipCode}
                  onChange={(e) => handleChange("zipCode", e.target.value)}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  type="number"
                  label="Latitude"
                  value={form.latitude}
                  onChange={(e) =>
                    handleChange("latitude", parseFloat(e.target.value))
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  type="number"
                  label="Longitude"
                  value={form.longitude}
                  onChange={(e) =>
                    handleChange("longitude", parseFloat(e.target.value))
                  }
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Status */}
        <Grid size={12}>
          <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h6" gutterBottom>
              ✅ Status
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <FormControlLabel
              control={
                <Checkbox
                  checked={form.isApproved}
                  onChange={(e) => handleChange("isApproved", e.target.checked)}
                />
              }
              label="Approved"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.isDelete}
                  onChange={(e) => handleChange("isDelete", e.target.checked)}
                />
              }
              label="Deleted"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.addressIsDelete}
                  onChange={(e) =>
                    handleChange("addressIsDelete", e.target.checked)
                  }
                />
              }
              label="Address Deleted"
            />
          </Paper>
        </Grid>

        {/* Profile Image */}
        <Grid size={12}>
          <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h6" gutterBottom>
              🖼️ Profile Image
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Box
              sx={{
                cursor: "pointer",
                border: "2px dashed #ccc",
                width: 1000,
                borderRadius: 3,
                p: 4,
                marginLeft: "60px",
                textAlign: "center",
              }}
              component="label"
              htmlFor="file-upload"
            >
              <input
                type="file"
                id="file-upload"
                hidden
                accept="image/*"
                onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0];
                  if (!file) return;

                  const previewUrl = URL.createObjectURL(file);
                  setForm((prev) => ({
                    ...prev,
                    profileImagePath: previewUrl,
                  }));

                  const res = await UploadImages(
                    file,
                    "venue",
                    "689c2d729c634fa1bc255d14"
                  );
                  if (res?.location) {
                    setForm((prev) => ({
                      ...prev,
                      profileImagePath: res.location,
                    }));
                  }
                }}
              />
              <img
                src={form.profileImagePath || uploadicon}
                alt="Preview"
                style={{
                  height: 100,
                  borderRadius: "8px",
                  objectFit: "cover",
                }}
              />
              <Typography variant="body2" sx={{ mt: 1 }}>
                Click to upload
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Submit */}
        <Grid size={12} textAlign="center">
          <Button
            style={{ backgroundColor: "black" }}
            variant="contained"
            size="large"
            onClick={handleSubmit}
          >
            💾 Save User
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
